/** Dispatch event on mouse click or on keyboard Enter key */

import { getRootDocument } from "$/utils/Utils";

export function clickAction(node, action) {
    node.setAttribute("role", "button");
    node.setAttribute("tabindex", "0");

    const handleClick = (event) => {
        if (node && node.contains(event.target) && !event.defaultPrevented) {
            action();
        }
    };

    const handleKeyDown = (event) => {
        if (
            node &&
            node.contains(event.target) &&
            event.key === "Enter" &&
            !event.defaultPrevented
        ) {
            action();
        }
    };

    getRootDocument().addEventListener("click", handleClick, true);
    getRootDocument().addEventListener("keydown", handleKeyDown, true);

    return {
        destroy() {
            getRootDocument().removeEventListener("click", handleClick, true);
            getRootDocument().addEventListener("keydown", handleKeyDown, true);
        },
    };
}
